import React, { Fragment, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  resetPassword,
  temporaryPasswordConfirm,
  resetUserPassword,
  clearEmail,
} from "../../actions/email";
import { setAlert } from "../../actions/alert";

import HomeFooterAlt from "../layout/IME/HomeFooterAlt";
import GreenLogo from "../layout/Innovators/GreenLogo";
import IMEAltLogo from "../layout/IME/IMEAltLogo";

const ForgotPassword = ({
  auth: { isAuthenticated },
  resetPassword,
  resetUserPassword,
  email: { userEmail, temporaryPassword, message },
  temporaryPasswordConfirm,
  setAlert,
  clearEmail,
}) => {
  const [email, setEmail] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const [temporary_password, setTemporaryPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [mismatchPassword, setMismatchPassword] = useState(
    "Passwords do not match"
  );

  const onSubmit = async (e, userEmail, temporary_password) => {
    e.preventDefault();
    if (temporary_password === "") {
      setAlert("Please enter temporary password");
    } else {
      temporaryPasswordConfirm(userEmail, temporary_password);
    }
  };

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <nav className="login-nav background-dark-black border-bottom grey">
        <div onClick={() => clearEmail()} className="action-items-index">
          <Link to="/">
            <div className={`action-button-index green`}>
              <i
                className={`fas fa-angle-left action-icon-index-alt green fa-lg`}
              ></i>
            </div>
          </Link>
          <p className={`action-text-index green`}>Back</p>
        </div>
        <Link to="/">
          <div className="center-nav">
            <div className="index-logo-alt">
              <GreenLogo />
            </div>
            <i className="fas fa-trademark fa-sm green mt-10"></i>
            <div className="index-logo">
              <IMEAltLogo />
            </div>
          </div>
        </Link>
      </nav>
      <div className="forgot-password-container">
        <div className="form-container">
          {confirmation && !temporaryPassword && (
            <div className="title-container">
              <p className="forgot-title green">Request Sent</p>
              <i className="far fa-check-circle question-mark"></i>
            </div>
          )}
          {confirmation && temporaryPassword && message !== "" && (
            <div className="title-container">
              <p className="forgot-title green">{message}</p>
              <i className="far fa-times-circle question-mark"></i>
            </div>
          )}
          {!confirmation && (
            <div className="title-container">
              <p className="forgot-title green">Forgot Password</p>
              <i className="far fa-question-circle question-mark"></i>
            </div>
          )}
          {confirmation && temporaryPassword && message === "" && (
            <div className="title-container">
              <p className="forgot-title green">Reset Password</p>
              <i className="fa-solid fa-lock question-mark"></i>
            </div>
          )}
          {confirmation && userEmail === "" && (
            <div className="directions-container">
              <div className="directions">
                Email submitted. If the email address submitted exists, you will
                be sent a temporary password to reset your password. <br />
                <br />
                Return to the homepage and login with your email and temporary
                password.
              </div>
            </div>
          )}
          {temporaryPassword && message === "" && (
            <div className="directions-container">
              <div className="directions">
                Temporary password successfully matched. Please reset and
                confirm your new password below:
              </div>
            </div>
          )}
          {confirmation && userEmail !== "" && !temporaryPassword && (
            <div className="directions-container">
              <div className="directions">
                Email successfully found. Please submit your temporary password
                sent to the email below to reset your password. Be sure to check
                your "spam" folder:
              </div>
            </div>
          )}
          {!confirmation && (
            <div className="directions-container">
              <div className="directions">
                Enter the email address associated with your account to receive
                a temporary password via email:
              </div>
            </div>
          )}
          {confirmation && userEmail !== "" && !temporaryPassword && (
            <div className="directions-container">
              <p className="email-found white">{userEmail}</p>
            </div>
          )}
          {!confirmation && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (email !== "") {
                  resetPassword(email);
                  setConfirmation(true);
                }
              }}
              className="form-control"
            >
              <label htmlFor="streamkey" className="container-label bold green">
                Email:
              </label>
              <input
                className="forgot-password-input"
                type="email"
                name="email"
                placeholder="Enter Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {email !== "" && (
                <button className="forgot-password-button" type="submit">
                  <i className="fas fa-envelope-open-text fa-lg mx-5"></i>Send
                  Email
                </button>
              )}
            </form>
          )}
          {confirmation && userEmail !== "" && !temporaryPassword && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (userEmail !== "" && temporary_password !== "") {
                  onSubmit(e, userEmail, temporary_password);
                }
              }}
              className="form-control"
            >
              <label htmlFor="streamkey" className="container-label bold green">
                Temporary Password:
              </label>
              {message !== "" && (
                <label htmlFor="streamkey" className="container-label bold red">
                  {message}
                </label>
              )}
              <input
                className="forgot-password-input"
                type="text"
                name="temporary_password"
                placeholder="Enter Temporary Password"
                value={temporary_password}
                onChange={(e) => setTemporaryPassword(e.target.value)}
              />
              {temporary_password !== "" && (
                <button className="forgot-password-button" type="submit">
                  <i className="fa-solid fa-unlock-keyhole fa-lg mx-5"></i>
                  Submit Temporary Password
                </button>
              )}
            </form>
          )}
          {temporaryPassword && message === "" && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (
                  newPassword !== "" &&
                  confirmNewPassword !== "" &&
                  newPassword === confirmNewPassword
                ) {
                  resetUserPassword(email, newPassword);
                }
              }}
              className="form-control"
            >
              <label htmlFor="streamkey" className="container-label bold green">
                New Password:
              </label>
              {newPassword === "" && confirmNewPassword === "" && (
                <label htmlFor="streamkey" className="container-label bold red">
                  {mismatchPassword}
                </label>
              )}
              {newPassword !== "" && newPassword !== confirmNewPassword && (
                <label htmlFor="streamkey" className="container-label bold red">
                  {mismatchPassword}
                </label>
              )}
              <input
                className="forgot-password-input"
                type="password"
                name="new_password"
                placeholder="Enter New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <label htmlFor="streamkey" className="container-label bold green">
                Confirm Password:
              </label>
              {newPassword === "" && confirmNewPassword === "" && (
                <label htmlFor="streamkey" className="container-label bold red">
                  {mismatchPassword}
                </label>
              )}
              {newPassword !== "" && newPassword !== confirmNewPassword && (
                <label htmlFor="streamkey" className="container-label bold red">
                  {mismatchPassword}
                </label>
              )}
              <input
                className="forgot-password-input"
                type="password"
                name="confirm_new_password"
                placeholder="Confirm New Password"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
              />
              {newPassword !== "" &&
                confirmNewPassword !== "" &&
                newPassword === confirmNewPassword && (
                  <button className="forgot-password-button" type="submit">
                    <i className="fa-solid fa-key fa-lg mx-5"></i>
                    Reset Password
                  </button>
                )}
            </form>
          )}
        </div>
      </div>
      <HomeFooterAlt />
    </Fragment>
  );
};

ForgotPassword.propTypes = {
  auth: PropTypes.object.isRequired,
  email: PropTypes.object.isRequired,
  resetPassword: PropTypes.func.isRequired,
  resetUserPassword: PropTypes.func.isRequired,
  temporaryPasswordConfirm: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
  clearEmail: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  email: state.email,
});

export default connect(mapStateToProps, {
  resetPassword,
  resetUserPassword,
  temporaryPasswordConfirm,
  setAlert,
  clearEmail,
})(ForgotPassword);
